import Button from "../../components/Button";
import PageTitle from "../../components/PageTitle";
import styles from "./NotFoundPage.module.css";

type NotFoundPageProps = {
  requestedUrl?: string;
};

function NotFoundPage({ requestedUrl }: NotFoundPageProps) {
  const normalizedRequestedUrl = requestedUrl?.trim();
  const subtitle = normalizedRequestedUrl
    ? `The requested page ${normalizedRequestedUrl} was not found`
    : "The requested page was not found";

  return (
    <div className={styles.page}>
      <PageTitle title="404" subtitle={subtitle} />
      <Button variant="secondary" onClick={() => location.assign("/")}>
        Return home
      </Button>
    </div>
  );
}

export default NotFoundPage;
